import type { NodeDefinition } from '../../../types/node-definition';

const definition: NodeDefinition = {
  "type": "jira",
  "name": "Jira",
  "category": "integrations",
  "description": "Create and manage Jira issues and projects",
  "icon": "siJira",
  "iconType": "simple-icon",
  "color": "blue",
  "version": "1.6.0",
  "group": [
    "transform"
  ],
  "defaults": {
    "name": "Jira",
    "color": "#0052cc"
  },
  "credentials": [
    {
      "name": "jiraCloudApi",
      "required": true,
      "displayName": "Jira Cloud API"
    }
  ],
  "inputs": [
    {
      "name": "default",
      "type": "main",
      "displayName": "Input",
      "required": true
    }
  ],
  "outputs": [
    {
      "name": "default",
      "type": "main",
      "displayName": "Output"
    }
  ],
  "tags": [
    "jira",
    "issues",
    "project-management",
    "atlassian",
    "tickets"
  ],
  "comingSoon": true
};

export default definition;
